import {
  authTypes,
  registerTypes, 
  resetPasswordTypes,
  changePasswordTypes,
} from '../actions/auth/types';
import types from '../actions/types';

const initialState = {
  email: '',
};

const cleanableState = {
  isLoggedIn: false,
  errorMessage: null,
  isLoading: false,
  resultMessage: null,
  sendingPolicyByMail: false,
};

const authReducer = (state = {...initialState, ...cleanableState}, action) => {
  const { type, payload } = action;
  switch (type) {
    
    case types.CLEAN:
    case authTypes.RESET:
      return { ...state, ...cleanableState};
      
    case authTypes.REQUEST: {
      return {
        ...state,
        isLoading: true,
        errorMessage: null,
        resultMessage: null,
        sendingPolicyByMail: false,
      };
    }
    
    case authTypes.SENDING_POLICY: {
      return {
        ...state,
        sendingPolicyByMail: payload,
      };
    }

    case registerTypes.SUCCESS: {
      return {
        ...state,
        isLoading: false,
        errorMessage: null,
        resultMessage: payload
      };
    }
    case registerTypes.FAILED: {
      return {
        ...state,
        isLoading: false,
        resultMessage: null,
        errorMessage: payload,
      };
    }

    case resetPasswordTypes.SUCCESS: {
      return {
        ...state,
        isLoading: false,
        resultMessage: 'SUCCESS',
      };
    }
    case resetPasswordTypes.FAILED: {
      return {
        ...state,
        isLoading: false,
        resultMessage: payload,
      };
    }
    
    case changePasswordTypes.SUCCESS: {
      return {
        ...state,
        isLoading: false,
        result: 'SUCCESS',
      };
    }
    case changePasswordTypes.FAILED: {
      return {
        ...state,
        isLoading: false,
        result: payload,
      };
    }

    default:
      return state;
  }
};
  
export default authReducer;
